export const longBeep = new Audio(process.env.PUBLIC_URL + '/audio/long-beep.mp3');
export const shortBeep = new Audio(process.env.PUBLIC_URL + '/audio/short-beep.mp3');
